<template>
    <b-container fluid class="mt--7">
        <manage-password title="User Profile" />
    </b-container>
</template>

<script>
import ManagePassword from '../components/ManagePassword.vue'

export default {
    components: { ManagePassword },
    name: 'UserProfile',
}
</script>